const listen = (el, event, callback) => {
  el.addEventListener(event, callback)
  return () => {
    el.removeEventListener(event, callback)
  }
}

export default listen



// WEBPACK FOOTER //
// ./src/util/listen.js